// vim: set ts=2 sts=2 sw=2 et:

import React from "react";
import { useLocation, useParams } from "react-router-dom";

import { parsePlatformRef } from "../operation/platformRef";
import BroadcastOverlay from "./BroadcastOverlay";
import StreamingLiveClient from "./StreamingLiveClient";

const OverlayStreamingRoute = () => {
  const params = useParams();
  const location = useLocation();
  const platformRef = parsePlatformRef(params.day, params.platformId);
  // Fondo blanco por defecto; ?fondo=transparente para una fuente de navegador de OBS con transparencia.
  const transparent = new URLSearchParams(location.search).get("fondo") === "transparente";

  React.useEffect(() => {
    document.body.classList.add("wrpf-streaming-overlay");
    if (transparent) {
      document.body.classList.add("wrpf-streaming-overlay-transparent");
      document.documentElement.classList.add("wrpf-streaming-overlay-transparent");
    }
    return () => {
      document.body.classList.remove("wrpf-streaming-overlay", "wrpf-streaming-overlay-transparent");
      document.documentElement.classList.remove("wrpf-streaming-overlay-transparent");
    };
  }, [transparent]);

  // Pure WebSocket display: only a well-formed URL is required (the local meet is irrelevant — the
  // overlay renders entirely from the live broadcast and the stream device often has no meet loaded).
  if (platformRef === null) return <main role="alert">Invalid Streaming URL</main>;
  return (
    <StreamingLiveClient platformRef={platformRef} locationSearch={location.search} followPolicy="result-reveal">
      {(state) => <BroadcastOverlay {...state} />}
    </StreamingLiveClient>
  );
};

export default OverlayStreamingRoute;
